import { Box, Flex, Text } from '@chakra-ui/layout';
import { Switch, useColorMode } from '@chakra-ui/react';
import React, { useState } from 'react';
import { ExplorerDataType, getExplorerLink } from '../../utils/getExplorerLink';

const SocialMediaLinks = ({connectWallet,feelingLucky,reset,searchForAddress,address}:any) => {
 
  return (
    <Flex justifyContent="space-between" mt="23px" fontSize="12px" width="100%" minWidth="100%" color="white" mx="auto">
    {/* <Text cursor="pointer">CONNECT WALLET</Text> */}
    <Text onClick={connectWallet} cursor="pointer" ml="10px" borderRadius="5px" border="1px solid white" fontSize="13px" padding="2px 15px" >Miner</Text>
    <Text onClick={feelingLucky} cursor="pointer" ml="10px" borderRadius="5px" border="1px solid white" fontSize="13px" padding="2px 15px" > Address</Text>
    <Text onClick={()=>reset()} cursor="pointer" ml="10px" borderRadius="5px" border="1px solid white" fontSize="13px" padding="2px 15px" >Edit</Text>
    <Text onClick={searchForAddress} cursor="pointer" ml="10px" borderRadius="5px" border="1px solid white" fontSize="13px" padding="2px 15px" >Show all Tokens</Text>
    <Text onClick={()=>window.open(getExplorerLink(1, address, ExplorerDataType.ADDRESS))} cursor="pointer" ml="10px" borderRadius="5px" border="1px solid white" fontSize="13px" padding="2px 15px" >Etherscan</Text>
    <Text cursor="pointer" ml="10px" borderRadius="5px" border="1px solid white" fontSize="13px" padding="2px 15px" onClick={()=>window.open(`https://www.google.com/search?q=${address}`)} >Google</Text>
  </Flex>
  );
};

export default SocialMediaLinks;
